import React, { useEffect } from 'react';
import AOS from 'aos';
import { Helmet } from 'react-helmet-async';

function AboutUs() {
  const features = [
    {
      title: 'Skilled Experts',
      desc: 'Our crew is made up of certified professionals with a wealth of hands-on experience, dedicated to delivering top-tier results every time.',
      icon: '/Images/skilled-experts-icon.png',
    },
    {
      title: 'Exceptional Craftsmanship',
      desc: 'We combine premium-grade materials with cutting-edge tools and techniques to ensure every project exceeds expectations.',
      icon: '/Images/exceptional-craftsmanship-icon.png',
    },
    {
      title: 'Client-Focused Approach',
      desc: 'Your peace of mind is our mission. We go the extra mile to make sure the job is done to your complete satisfaction.',
      icon: '/Images/client-focused-icon.png',
    },
    {
      title: 'Always On Call',
      desc: 'Emergencies don’t follow a schedule and neither do we. Our team is available 24/7 to respond quickly whenever you need us.',
      icon: '/Images/always-on-call-icon.png',
    },
  ];

  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-out',
      once: true,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>About Us | On Point Services</title>
        <meta
          name="description"
          content="Learn about On Point Services: our mission, expert team, and commitment to quality maintenance and repair solutions."
        />
        <meta property="og:title" content="About Us | On Point Services" />
        <meta
          property="og:description"
          content="Discover the skilled experts and client-focused approach that set On Point Services apart in Alabama, Florida, Georgia, and Tennessee."
        />
        <link rel="canonical" href="https://www.on-point-services.com/aboutus" />
      </Helmet>
    
    <div className="about-us">
      <div className="top-section mb-5" data-aos="fade-up">
        <img
          src="/Images/Onpoin-maintenace-services.jpg"
          alt="Maintenance Services"
          className="img-fluid w-100"
        />
      </div>
      <div className="container">
        <div className="about-title text-center mb-4" data-aos="fade-up">
          About <span>Us</span>
        </div>
        <div className="row align-items-start mb-5">
          <div className="col-md-6 mb-4 mb-md-0">
            <div className="lead" data-aos="fade-right">
              At OnPoint Services, we believe the strength of our company
              lies in the talent and dedication of our team. Our experienced
              professionals are passionate about providing fast, reliable
              maintenance and repair solutions, backed by clear, consistent
              communication. We take pride in getting every job done correctly
              the first time, driven by a commitment to excellence and
              customer satisfaction.
            </div>
          </div>

          <div className="col-md-6">
            <div className="row g-4">
              {features.map(({ title, desc, icon }, idx) => (
                <div
                  key={title}
                  className="col-12 col-md-6"
                  data-aos={idx % 2 === 0 ? 'fade-left' : 'fade-right'}
                  data-aos-delay={idx * 200}
                >
                  <div className="d-flex align-items-start p-3">
                    <div className="me-3">
                      <img
                        src={icon}
                        alt={title}
                        className="about-icon"
                      />
                    </div>
                    <div>
                      <h5 className="mb-1 poppins-medium">{title}</h5>
                      <p className="mb-0">{desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default AboutUs;
